import {
	PAGE_TYPE_ECOMMERCE_DYNAMIC_PRODUCT,
	PAGE_TYPE_ECOMMERCE_PRODUCT,
} from '@zyro-inc/site-modules/constants';

export const isProductPage = (pageType: string) => [
	PAGE_TYPE_ECOMMERCE_DYNAMIC_PRODUCT,
	PAGE_TYPE_ECOMMERCE_PRODUCT,
].includes(pageType);
